type HasPrice = {
	price: number;
};

type Rng = () => number;

const shuffleInPlace = <T>(items: T[], rng: Rng) => {
	for (let i = items.length - 1; i > 0; i--) {
		const j = Math.floor(rng() * (i + 1));
		[items[i], items[j]] = [items[j], items[i]];
	}
};

export function shuffleSamePriceRuns<T extends HasPrice>(
	items: readonly T[],
	rng: Rng = Math.random,
): T[] {
	const result = [...items];
	let i = 0;
	while (i < result.length) {
		const price = result[i]?.price;
		let j = i + 1;
		while (j < result.length && result[j]?.price === price) {
			j++;
		}
		if (j - i > 1) {
			const run = result.slice(i, j);
			shuffleInPlace(run, rng);
			for (let k = 0; k < run.length; k++) {
				result[i + k] = run[k];
			}
		}
		i = j;
	}
	return result;
}
